import { logNewRelicPageAction } from '@makemydeal/dr-activities-common';
import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import { CALC_ENDPOINTS } from '../constants';
import { getCalculationEndpointsState, getDealerForcedUpq } from '../selectors/offerNodeSelectors';
import * as types from '../types/actionTypes';

export const autoSelectProgramGuardMiddleware = (store: any) => (next: any) => (action: AnyFSA) => {
    if (
        action.type === types.UPDATE_CURRENT_CALCULATION_ENDPOINT &&
        action.payload === CALC_ENDPOINTS.programQuotes &&
        getDealerForcedUpq(store.getState())
    ) {
        logNewRelicPageAction('autoSelectProgramGuardSwallowed', {
            attemptedEndpoint: CALC_ENDPOINTS.programQuotes,
            marker: getCalculationEndpointsState(store.getState())?.autoSelectProgramSavedAt || 'none'
        });
        return action;
    }
    return next(action);
};
